<template>
  <v-container class="h-100 pa-4" fluid>
    <v-row justify="center" class="h-100">
      <v-sheet class="bg-background flex-1-1 px-4" max-width="420">
        <router-link :to="{ name: 'Login' }"
          ><v-img class="mx-auto mb-4" :src="LOGO_HEADER" contain
        /></router-link>
        <v-alert v-if="errors.apiError" type="error" class="mt-3"
          >{{ errors.apiError }}
          <a
            v-if="showValidationResend"
            class="text-decoration-none text-primary text-body-2 font-weight-medium"
            variant="text"
            @click="resendEmail"
            >Resend Validation Email</a
          >
        </v-alert>
        <div v-else>Your account is ready.</div>
        <router-link :to="{ name: 'Login' }">
          <v-btn block color="primary" class="rounded-lg mb-8" elevation="2" type="submit"
            >Return To Login</v-btn
          >
        </router-link>
      </v-sheet>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
import { useRoute } from 'vue-router';
import { ref, onMounted } from 'vue';
import { emailValidation, resendValidationEmail } from '@/controllers/authController.js';
import { LOGO_HEADER } from '@/helpers';

const route = useRoute();
const email_address: string = Array.isArray(route.query.email_address)
  ? route.query.email_address[0]?.toString() || ''
  : route.query.email_address?.toString() || '';

const queryParam: string = Array.isArray(route.query.token)
  ? route.query.token[0]?.toString() || ''
  : route.query.token?.toString() || '';

const showValidationResend = ref<boolean>(false);
const token = decodeURIComponent(queryParam);
const errors = ref<{ apiError: string | undefined }>({ apiError: '' });

const checkValidation = async () => {
  try {
    if (email_address != null && token != null) {
      const isVerified = await emailValidation(email_address, token);
      if (isVerified) {
        errors.value.apiError = undefined;
      }
    } else {
      errors.value.apiError = 'Invalid Parameters';
    }
  } catch {
    showValidationResend.value = true;
    errors.value.apiError = 'There was an issue with validation';
  }
};

const resendEmail = async () => {
  if (email_address) {
    try {
      var results = await resendValidationEmail(email_address);
      if (results) {
        errors.value.apiError = '';
        showValidationResend.value = false;
      }
    } catch {}
  }
};
onMounted(() => {
  checkValidation();
});
</script>
